'use strict';

const jQuery = require('jquery');

export default ReportHistoryCategorySelect;

const REPORT_HISTORY_CATEGORY_SELECT_COMPONENT_ATTR = 'data-report-history-category-select';
const REPORT_HISTORY_CATEGORY_SELECT_COMPONENT_SELECTOR = '[' + REPORT_HISTORY_CATEGORY_SELECT_COMPONENT_ATTR + ']';
const REPORT_HISTORY_CATEGORY_SELECT_CATEGORY = '[data-report-history-category-select-category]';
const REPORT_HISTORY_CATEGORY_SELECT_ELEMENT = '[data-report-history-category-select-element]';
const REPORT_HISTORY_CATEGORY_BUTTON_GENERATE = '[data-report-history-category-select-generate]';
const REPORT_HISTORY_CATEGORY_SELECT_EMPTY_TEMPLATE = '<option selected disabled>Maak een keuze...</option>';

class ReportHistoryCategorySelect {

    constructor(element) {
        const component = this;

        component.element = jQuery(element);
        component.selectCategory = component.element.find(REPORT_HISTORY_CATEGORY_SELECT_CATEGORY);
        component.selectElement = component.element.find(REPORT_HISTORY_CATEGORY_SELECT_ELEMENT);
        component.buttonGenerate = component.element.find(REPORT_HISTORY_CATEGORY_BUTTON_GENERATE);

        component.selectElement.prop('disabled', true);
        component.buttonGenerate.prop('disabled', true);

        component.selectCategory.on('change', () => {
            var category = component.selectCategory.find(':selected').attr('value');

            component.getElements(category);
        });

        component.selectElement.on('change', () => {
            component.buttonGenerate.prop('disabled', false);
        });
    }

    getElements(category) {
        const component = this;

        jQuery.ajax({
            url: base_url + '/api/get/history/category/elements/',
            data: {
                category
            },
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })

        .then(response => {
            if (!response.length) {
                throw Error('Unexpected return');
            }

            return response;
        })

        .then(response => {
            if (response.length > 0) {
                component.populateElementSelect(response);
            } else {
                component.disableElementSelect();
            }
        })
    }

    populateElementSelect(response) {
        const component = this;

        component.response = response;

        component.selectElement.empty();
        component.selectElement.prop('disabled', false);
        component.selectElement.append(REPORT_HISTORY_CATEGORY_SELECT_EMPTY_TEMPLATE);

        component.response.forEach(element => {
            component.selectElement.append(`<option value="${element.id}">${element.naam}</option>`);
        });
    }

    disableElementSelect() {
        const component = this;

        component.selectElement.empty();
        component.selectElement.prop('disabled', true);
        component.selectElement.append(REPORT_HISTORY_CATEGORY_SELECT_EMPTY_TEMPLATE);
    }

}

jQuery(REPORT_HISTORY_CATEGORY_SELECT_COMPONENT_SELECTOR).each((index, element) => new ReportHistoryCategorySelect(element));
